<script lang="ts">
  import type { Filter, FilterTypesType } from "@shared/types/Filters";

  export let updateFilter: any;
  export let updateSearch: any;
  export let updateSelected: any;
  export let count: any;
  export let filter: FilterTypesType;
  export let filters: Filter[];
  export let searchText = null;
  export let countWithoutSearch: any = null;
  export let filterExpanded: boolean = false;
  export let filterIndex: number | null = null;
  export let hidden: boolean = false;

  const countWithoutSearchLimit = 50;

  let checkedItems = [];
  // Remove invalid filter values
  let removeInvalidFilters = (filters: any) => {
    return filters.filter((f: any) => {
      if (filter.validate !== undefined) {
        return filter.validate(f);
      } else {
        return true;
      }
    });
  };

  let searchTimer: any;
  const debounceSearch = (v: any) => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      searchText = v;
      updateSearch(filter, searchText);
    }, 750);
  };

  const clearSearch = () => {
    searchText = "";
    updateSearch(filter, searchText);
  };

  let updateSelectedFilters = (filters: any) => {
    updateSelected(filters, filter);
  };

  let updateCountWithoutSearch = (count: any) => {
    if (!searchText) {
      countWithoutSearch = count;
    }
  };
  updateCountWithoutSearch(count);

  $: updateCountWithoutSearch(count);
  $: updateSelectedFilters(filters);
  $: filters = removeInvalidFilters(filters);

  $: checkedItems = filters.filter(p => p.checked == true);

  let filtersSelected = searchText.length > 0 || checkedItems.length > 0;
  let showFilters: any;

  $: filtersSelected = searchText.length > 0 || checkedItems.length > 0;
  $: showFilters = filterExpanded || (filterExpanded === null && (filtersSelected || showFilters));
  const showSearch = countWithoutSearch >= countWithoutSearchLimit || searchText;

  const runDebounce = function (event: KeyboardEvent) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    debounceSearch(target.value);
  };

</script>

<style>
  .priority-hide {
    display: none !important;
  }

  .item-count-margin {
    margin-left: auto;
  }

</style>

<div
  class="fizz-card side-filter fizz-inset-vertical-8"
  class:priority-hide={hidden}
  id={filter.id + "-filter"}
>
  <details class="fizz-accordion" open={showFilters || searchText}>
    <summary class="side-filter-header" data-testid={"product-lines-filter-" + filterIndex}
      ><span class="fizz-heading-6">{filter.name}</span></summary
    >
    <div class="fizz-inset-horizontal-16 fizz-flow-8{showSearch ? '' : ' fizz-inset-vertical-8'}">
      {#if showSearch}
        <div class="fizz-inset-vertical-8 side-filter-search-container">
          <div class="fizz-relative fizz-inline-block fizz-full-width">
            <div class="fizz-input-text fizz-input-with-button side-filter-search">
              <input
                type="text"
                id={filter.id + "-input-search"}
                name="input-search"
                class="side-filter-search-input side-filter-search-input"
                on:keyup|stopPropagation={runDebounce}
                placeholder="Search..."
                value={searchText}
              />
            </div>
            {#if searchText.length > 0}
              <button class="fizz-icon-button-small" on:click|stopPropagation={clearSearch}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="fizz-icon-16">
                  <path
                    d="M30 4.8L27.2 2 16 13.2 4.8 2 2 4.8 13.2 16 2 27.2 4.8 30 16 18.8 27.2 30l2.8-2.8L18.8 16z"
                  />
                </svg>
              </button>
            {/if}
          </div>
        </div>
      {/if}
      {#if filters && filters.length > 0}
        <dl
          class="fizz-overflow-y side-filter__list"
          class:priority-hide={hidden}
          style="max-height: 12em;"
        >
          {#each filters as item}
            <dt item-id={item.id} class="side-filter__item">
              <label
                class="fizz-flex-row-8 fizz-stack-4 cursor-pointer fizz-relative"
                for={filter.id + "-" + item.id}
              >
                <input
                  type="checkbox"
                  class="fizz-checkbox fizz-absolute"
                  style="top: 2px;"
                  name="checkbox"
                  id={filter.id + "-" + item.id}
                  bind:checked={item.checked}
                  on:change={() => updateFilter(filter, item)}
                />

                <span class="fizz-clamp" style="margin-left: 24px;">
                  {@html item.highlight || item.name || item.id || item}
                </span>
                {#if item.count}
                  <span class="fizz-text-subdued item-count-margin fizz-align-self-start"
                    >({item.count})</span
                  >
                {/if}
              </label>
            </dt>
          {/each}
        </dl>
      {:else}
        <div class="margin--smallest side-filter-no-results">
          <span class="fizz-text-medium">Nothing matches your search</span>
        </div>
      {/if}
    </div>
  </details>
</div>
